export enum DOCTOR_VENDOR_TYPE {
    KYRUUS = "KYRUUS",
    SAPPHIRE_DIGITAL = "SAPPHIRE_DIGITAL"
}